import React from "react";

export const BoxIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00033 0.666016L14.3337 4.33268V11.666L8.00033 15.3327L1.66699 11.666V4.33268L8.00033 0.666016ZM3.66291 4.71782L8.00039 7.22895L12.3378 4.71784L8.00033 2.20668L3.66291 4.71782ZM3.00033 5.87488V10.8973L7.33373 13.4061V8.38368L3.00033 5.87488ZM8.66706 13.406L13.0003 10.8973V5.87493L8.66706 8.38368V13.406Z"
        fill="currentColor"
      />
    </svg>
  );
};
